<template>
  <v-menu rounded="0" transition="slide-x-transition" bottom left>
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        color="greenMain"
        small
        tile
        elevation="0"
        class="ma-0 text-capitalize btn-account"
        v-bind="attrs"
        v-on="on"
      >
        Create Account
        <v-icon right :color="$vuetify.theme.dark ? '#111A26' : '#fff'">
          mdi-chevron-down
        </v-icon>
      </v-btn>
    </template>
    <v-card class="dropdown-menu-card" tile flat>
      <v-list
        flat
        outlined
        :color="$vuetify.theme.dark ? '#111A26' : '#F1F7FB'"
      >
        <v-list-item-group>
          <v-list-item v-for="(item, i) in items" :key="i" :ripple="false">
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <router-link
                v-text="item.text"
                class="text-decoration-none"
                router
                :to="item.link"
              ></router-link>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        text: "Create Live Account",
        icon: "mdi-signal",
        link: "/create-live-account",
      },
      // {
      //   text: "Create TradeMaster Investor Account",
      //   icon: "mdi-currency-usd",
      //   link: "/create-investor-account?type=trademaster",
      // },
      {
        text: "Create Investor Account",
        icon: "mdi-currency-usd",
        link: "/create-investor-account?type=general",
      },
      {
        text: "Create Manager Account",
        icon: "mdi-account-tie",
        link: "/create-manager-account",
      },
    ],
  }),
};
</script>

<style></style>
